// Curated imagery for KBX Pathways To Wellness.
// Selected to predominantly feature Black/African American subjects (KBX is a Black-led
// agency serving the broader community), with diverse representation as accent imagery.

const U = (id, w = 1400, q = 80) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=${q}`;

// Primary Black-centric photography
export const IMG_BLACK_PROFESSIONALS_BOARDROOM = U("1573164574572-cb89e39749b4");
export const IMG_BLACK_WOMAN_PROFESSIONAL = U("1573497019418-b400bb3ab074");
export const IMG_BLACK_WOMEN_COLLAB = U("1573164713619-24c711fe7878");

// Diverse-hands community image (used sparingly as the ~15% broader representation)
export const IMG_DIVERSE_HANDS = U("1582213782179-e0d53f98f2ca");

// Page assignments
export const PAGE_IMAGES = {
  homeHero: IMG_BLACK_PROFESSIONALS_BOARDROOM,
  homeConsulting: IMG_BLACK_PROFESSIONALS_BOARDROOM,
  homePeer: IMG_BLACK_WOMEN_COLLAB,
  homeTrust: IMG_DIVERSE_HANDS,
  consulting: IMG_BLACK_PROFESSIONALS_BOARDROOM,
  peerSupport: IMG_BLACK_WOMEN_COLLAB,
  about: IMG_BLACK_WOMAN_PROFESSIONAL,
};
